import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import { PersistGate } from 'redux-persist/integration/react';

import * as serviceWorker from './serviceWorker';
import App from './App';
import { Provider } from 'react-redux';
import AuthProvider from './common/Providers/AuthProvider';
import userManager from './services/actions/Autenticacao/AuthService';
import { BrowserRouter } from 'react-router-dom/cjs/react-router-dom.min';
import { store, persistor } from './store';


ReactDOM.render(
  <Provider store={store}>
    <PersistGate loading={null} persistor={persistor}>
      <AuthProvider userManager={userManager} store={store}>
        <BrowserRouter>
            <App />
        </BrowserRouter>
      </AuthProvider>
    </PersistGate>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
